module.exports = __webpack_public_path__ + "img/632c8c4.webp";